import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Store, Lock, Mail } from "lucide-react";
import { toast } from "sonner";

export default function OwnerLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("owner@kasir.com");
  const [password, setPassword] = useState("owner123");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Berhasil masuk");
      const to = location.state?.from || "/owner";
      navigate(to, { replace: true });
    } catch (e) {
      const d = e.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Gagal masuk");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-[#F9F9F6] to-[#EAE7DF]">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-14 h-14 rounded-2xl bg-[#1E3A2B] text-white flex items-center justify-center mx-auto mb-4">
            <Store className="w-6 h-6" />
          </div>
          <h1 className="font-display text-3xl font-semibold text-[#1E3A2B]">Masuk sebagai Owner</h1>
          <p className="text-[#5C6A61] mt-2">Kelola menu, pesanan, dan laporan kasir</p>
        </div>
        <form onSubmit={onSubmit} className="bg-white rounded-2xl border border-[#D3CEC4] p-6 shadow-[0_8px_32px_rgba(30,58,43,0.06)]" data-testid="owner-login-form">
          <label className="block mb-4">
            <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#5C6A61]">Email</span>
            <div className="relative mt-1.5">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#5C6A61]" />
              <input
                type="email"
                data-testid="login-email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full border border-[#D3CEC4] bg-white rounded-xl pl-10 pr-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#C25934]/30 focus:border-[#C25934]"
                required
              />
            </div>
          </label>
          <label className="block mb-4">
            <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#5C6A61]">Kata Sandi</span>
            <div className="relative mt-1.5">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#5C6A61]" />
              <input
                type="password"
                data-testid="login-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full border border-[#D3CEC4] bg-white rounded-xl pl-10 pr-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#C25934]/30 focus:border-[#C25934]"
                required
              />
            </div>
          </label>
          {err && <div className="text-sm text-[#D64045] mb-3" data-testid="login-error">{err}</div>}
          <button
            type="submit"
            disabled={loading}
            data-testid="btn-login"
            className="w-full bg-[#C25934] text-white hover:bg-[#A94726] transition-colors px-6 py-3 rounded-xl font-medium disabled:opacity-60"
          >
            {loading ? "Memproses..." : "Masuk"}
          </button>
          <div className="mt-4 text-xs text-[#5C6A61] text-center">
            Default: owner@kasir.com / owner123
          </div>
        </form>
      </div>
    </div>
  );
}
